import React, { useEffect, useState } from "react";
import { Card, Container, ListGroup } from "react-bootstrap";
import { GetUserNotification } from "../../utilities/api/dashboard";
import { toast } from "react-toastify";

const CustomerNotification = () => {
    const [notification, setNotification] = useState<any>({});

    const handleGetNotification = async (page: any = 1) => {
        let _notification = await GetUserNotification(page)
        if (_notification.statusCode === 200) {
            setNotification(_notification.data)
        } else {
            toast.error(_notification.response.data.message)
        }
    }

    const NextPage = (page: any) => {
        handleGetNotification(page)
    }

    const PreviousPage = (page: any) => {
        handleGetNotification(page)
    }

    useEffect(() => {
        handleGetNotification();
    }, [])

    return (
        <>
            <Container fluid className="g-0">
                <Card className="border-0">
                    <Card.Body className="p-0 text-start">
                        <ListGroup as="ol">
                            {!notification?.rows?.length && (
                                <ListGroup.Item className="text-center py-4 text-muted">No data found</ListGroup.Item>
                            )}
                            {notification?.rows?.map((item: any, index: number) => {
                                return (
                                    <ListGroup.Item action href="" key={index}
                                        as="li"
                                        className={item.isSeen ? "d-flex justify-content-between align-items-start px-4 py-3 bg-light opacity-75 disabled" : "d-flex justify-content-between align-items-start px-4 py-3"}
                                    >
                                        <div className="ps-3 me-auto bullet">
                                            <div className="fw-bold pb-2">{item.title}</div>
                                            <span className="text-info">{item.message}</span>
                                        </div>
                                        <span className="text-info text-nowrap">{item.createdAt}</span>
                                    </ListGroup.Item>
                                )
                            })}
                        </ListGroup>
                        <div className="pagination-section d-flex justify-content-end align-items-center me-4">
                            <span className="me-5 text-info">
                                Rows per Page:{" "}
                                <span className="text-dark">
                                    {notification?.limit}
                                </span>{" "}
                            </span>
                            <span className="text-info">{`${notification?.page} - ${notification?.totalPages} of ${notification?.totalRows}`}</span>
                            <input
                                type="button"
                                className="input-left-arrow ms-4"
                                disabled={notification?.page === 1}
                                onClick={() => PreviousPage(notification?.page - 1)}
                            />
                            <input
                                type="button"
                                className="input-right-arrow"
                                disabled={notification?.page >= notification?.totalPages}
                                onClick={() => NextPage(notification?.page + 1)}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}
export { CustomerNotification }